<mat-card class="about-card" style="overflow-x: hidden">
  <mat-card-header class="d-flex justify-content-center">
    <mat-card-title>Aquasafe</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <!--Aquasafe is a product of Hidromod.-->
    <p>Aquasafe é um produto da Hidromod.</p>
    <p>
      <!--For technical support and inquiries please contact.-->
      Para suporte técnico ou outras questões, por favor, contacte
      <a href="mailto:hidromod@hidromod.com">hidromod@hidromod.com</a> ou
      visite-nos em
      <a href="http://www.hidromod.com/">www.hidromod.com.</a>
    </p>
    <p>O serviço Aquasafe utiliza informação gerada por:</p>
    <div class="container-fluid">
      <div class="row d-flex align-items-center justify-content-center">
        <img
          class="col"
          style="max-width: 180px"
          src="assets/partners/copernicus_1.jpg"
        />
        <img
          class="col"
          style="max-width: 180px"
          src="assets/partners/copernicus_2.jpg"
        />
        <div class="col flex-column" style="max-width: 220px">
          <img
            style="max-width: 180px"
            src="assets/partners/meteogalicia.png"
          />
          <img style="max-width: 200px" src="assets/partners/raia.png" />
        </div>
        <img
          class="col"
          style="max-width: 180px"
          src="assets/partners/noa.jpg"
        />
        <img
          class="col"
          style="max-width: 180px"
          src="assets/partners/Icon.jpg"
        />
        <img
          class="col"
          style="max-width: 180px"
          src="assets/partners/hidrografico.svg"
        />
      </div>
    </div>
    <p style="font-size: smaller; text-align: end" class="mt-2">
      Windmill animation by @Erick Daniel Juarez Gil / LottieFiles.
    </p>
  </mat-card-content>
  <mat-card-actions class="d-flex justify-content-center">
    <button
      mat-button
      [mat-dialog-close]="true"
      style="background-color: rgb(111, 194, 233)"
    >
      Ok
    </button>
  </mat-card-actions>
</mat-card>
